import { ReactElement, useState } from 'react'
import classNames from 'classnames'
import { IconButton, Paragraph } from '@alto-avios/alto-ui'
import { IQuantityPicker } from './interface'
import styles from './QuantityPicker.module.scss'

type ButtonType = 'minus' | 'plus'

export default function QuantityPicker({
  min,
  max,
  defaultValue,
  onSelect,
  label,
  variant = 'success',
}: IQuantityPicker): ReactElement {
  const [selectValue, setSelectValue] = useState<number>(defaultValue)

  const setValue = (type: ButtonType) => {
    let boxValue
    if (type === 'minus') {
      boxValue = selectValue > min ? selectValue - 1 : min
    } else {
      boxValue = selectValue < max ? selectValue + 1 : max
    }
    setSelectValue(boxValue)
    if (onSelect) {
      onSelect(boxValue)
    }
  }

  const getButtonLabel = (type: ButtonType) => {
    const labels = {
      plus: 'add',
      minus: 'remove',
    }
    let buttonLabel = labels[type]
    if (label) {
      buttonLabel += ` ${label}`
    }
    return buttonLabel
  }

  return (
    <div
      data-testid="quantity-picker"
      className={classNames(styles.quantityPickerContainer, styles[variant])}
    >
      <IconButton
        styleVariant="white"
        iconProps={{
          iconName: 'circle-minus',
          iconSize: 'lg',
        }}
        isDisabled={selectValue <= min}
        onPress={() => {
          setValue('minus')
        }}
        aria-label={getButtonLabel('minus')}
      />
      <Paragraph>{selectValue}</Paragraph>
      <IconButton
        styleVariant="white"
        iconProps={{
          iconName: 'circle-plus',
          iconSize: 'lg',
        }}
        isDisabled={selectValue >= max}
        onPress={() => {
          setValue('plus')
        }}
        aria-label={getButtonLabel('plus')}
      />
    </div>
  )
}
